import { render, staticRenderFns } from "./annual-sale-2020-countdown.vue?vue&type=template&id=8acda1c2&scoped=true&"
import script from "./annual-sale-2020-countdown.vue?vue&type=script&lang=js&"
export * from "./annual-sale-2020-countdown.vue?vue&type=script&lang=js&"
import style0 from "./annual-sale-2020-countdown.vue?vue&type=style&index=0&id=8acda1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acda1c2",
  null
  
)

export default component.exports